// Section clicks, picks + views -> GTM "GA4event" pass-through; clicks also tag Clarity. Sitewide; layout shifts on collection pages only.
(function () {
  if (window.Shopify && Shopify.designMode) return;
  const template = (document.currentScript && document.currentScript.dataset.template) || 'page';
  const theme = window.Shopify && Shopify.theme;
  // Rollouts groups never read "main", so the store domain counts; preview links stay quiet
  const live = !!(theme && (theme.role === 'main' || !/\.(shopifypreview|myshopify)\.com$/.test(location.hostname)));
  const main = document.getElementById('MainContent');

  // Readable names: "Collection: Sleepwear / 04 Product grid", "Home / Header topbar"
  const readable = (s) =>
    s.replace(/[-_]+/g, ' ').trim().replace(/[a-z]/i, (c) => c.toUpperCase()).replace(/\b(nfl|nba|mlb|nhl|ncaa)\b/gi, (w) => w.toUpperCase());
  const [type, suffix] = template.split('.');
  const [base, sub] = type.split('/');
  const pageName = { index: 'Home', 'list-collections': 'All collections', customers: 'Account' }[base] || readable(base);
  const detail = suffix || (sub !== 'account' && sub);
  const templateName = detail ? `${pageName}: ${readable(detail)}` : pageName;

  window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
  // Clarity only hears from the published theme; previews just log, like the GA4 payloads
  const toClarity = (...args) => (live ? clarity(...args) : console.debug('[section-tracking]', 'clarity', ...args));
  const themeName = theme && theme.name ? theme.name.split('/').pop() : '';
  if (themeName) toClarity('set', 'theme', themeName);
  toClarity('set', 'page_type', pageName);
  toClarity('set', 'template', templateName);

  const clean = (s) => (s || '').replace(/\u2060/g, '').replace(/\s+/g, ' ').trim().slice(0, 80);
  const siteName = (document.querySelector('meta[property="og:site_name"]') || {}).content;
  // Visible text, else aria-label (unless it's just the site name), else image alt
  const linkText = (el) => {
    const aria = clean(el.getAttribute('aria-label'));
    const img = el.querySelector && el.querySelector('img[alt]');
    return clean(el.innerText) || (aria !== siteName && aria) || clean(img && img.alt);
  };
  const campaignLabel = (banner) => `Campaign banner: ${clean(banner.dataset.campaignName) || 'unnamed'}`;

  const area = (section) => {
    if (main && section.parentElement === main) {
      const position = [...main.children].filter((c) => c.classList.contains('shopify-section')).indexOf(section) + 1;
      return String(position).padStart(2, '0');
    }
    const group = section.className.match(/shopify-section-group-([\w-]+?)-group/);
    return group ? group[1] : 'other';
  };
  const parts = (section) => {
    const where = area(section);
    // Drops the editor's random 6-char code (hand-named ffsale, slider stay) and a repeated group name
    const what = section.id
      .split('__')
      .pop()
      .replace(/_(?!ffsale$|slider$)[A-Za-z0-9]{6}$/, '')
      .replace(new RegExp(`^${where}(?:[-_]|$)`), '')
      .replace(/^breadcrumbs_\w+$/, 'breadcrumbs');
    return [where, what];
  };
  const cardsOf = (section) => {
    const [where, what] = parts(section);
    if (what.startsWith('grid_banner')) return [...section.querySelectorAll('.grid-banner__item')];
    if (where === 'footer' && what.startsWith('multicolumn')) return [...section.querySelectorAll('.multicolumn-card')];
    if (what.startsWith('buttons_with_icon')) return [...section.querySelectorAll('.button-list__item')];
    if (what.startsWith('collection_list_slider')) return [...section.querySelectorAll('.swiper-slide')];
    return [];
  };
  // Cards tracked one by one: homepage grid banners and buttons (shop by child), the footer multicolumn (a one-card swiper on phones),
  // and sub-category slider tiles on every page, so a tile swiped into view counts as seen
  const trackedCards = (section) =>
    (pageName === 'Home' && main && section.parentElement === main) || area(section) === 'footer' || parts(section)[1].startsWith('collection_list_slider')
      ? cardsOf(section)
      : [];
  // Tracking name picked in the editor (snippets/tracking-name.liquid), else a grid banner names itself by card count
  const nameOf = (section) => {
    const marker = section.querySelector('template[data-tracking-name]');
    if (marker && clean(marker.dataset.trackingName)) return clean(marker.dataset.trackingName);
    const cards = /^(buttons_with_icon|collection_list_slider)/.test(parts(section)[1]) ? 0 : cardsOf(section).length;
    return cards ? `${cards}_column` : '';
  };
  // Header and footer names keep their group ("Home / Footer 3_column") so they never share a row with page sections
  const categoryOf = (section) => {
    const name = nameOf(section);
    const [where, what] = parts(section);
    if (name) return /^\d+$/.test(where) ? `${templateName} / ${name}` : `${templateName} / ${readable(where)} ${name}`;
    return `${templateName} / ${readable(`${where} ${what}`)}`;
  };
  // Hero: the first image at least 60% of the page's width, homepage and landing pages only
  let hero;
  const heroOf = () => {
    if (hero !== undefined) return hero;
    hero = null;
    if (!main || (pageName !== 'Home' && base !== 'page')) return hero;
    const wide = main.getBoundingClientRect().width * 0.6;
    const units = [...main.children].filter((c) => c.classList.contains('shopify-section')).flatMap((s) => (trackedCards(s).length ? trackedCards(s) : [s]));
    hero = units.find((u) => [...u.querySelectorAll('img')].some((img) => img.getBoundingClientRect().width >= wide)) || null;
    return hero;
  };
  // Section position: "4", "4-2" or "footer-2" for a tracked card, "header"/"footer" for groups, plus " hero". No leading 0: GA4 stores a bare "04" as 4
  const positionOf = (section, card) => {
    const where = area(section).replace(/^0+(?=\d)/, '');
    const cards = card ? trackedCards(section) : [];
    const position = cards.includes(card) ? `${where}-${cards.indexOf(card) + 1}` : where;
    const first = heroOf();
    return first && (first === section || first === card) ? `${position} hero` : position;
  };
  // Link numbers only where position is the lesson: homepage sections and the sub-category slider
  const numbered = (section) => {
    const [where, what] = parts(section);
    return (pageName === 'Home' && /^\d+$/.test(where)) || what === 'collection_list_slider';
  };
  const pathOf = (href) => {
    if (!href) return '';
    const url = new URL(href, location.origin);
    if (url.origin === location.origin && url.pathname === '/cart/change') return '/cart/change'; // line ids are unique per cart
    [...url.searchParams.keys()].filter((k) => /^(pr_|_)/.test(k)).forEach((k) => url.searchParams.delete(k)); // Shopify rec/search tracking params
    return url.origin === location.origin ? url.pathname + url.search : url.href;
  };
  // A view carries the link when everything in it goes to one place
  const linkOf = (el) => {
    const paths = [...new Set([...el.querySelectorAll('a[href]')].map((a) => pathOf(a.getAttribute('href'))))];
    return paths.length === 1 ? paths[0] : '';
  };
  // Submits that leave the page count as navigation: checkout and GET forms (search). Add to cart and other POSTs stay interactions
  const submitTo = (el) => {
    if (!el.form || el.type !== 'submit') return '';
    if (el.name === 'checkout') return '/checkout';
    return (el.form.getAttribute('method') || 'get').toLowerCase() === 'get' ? el.form.getAttribute('action') || '' : '';
  };
  // Clarity funnel steps, a short stable list: homepage sections, header, collection sub-category slider
  const stepOf = (section) => {
    const [where, what] = parts(section);
    if (pageName === 'Home' && /^\d+$/.test(where)) return nameOf(section) ? `Home ${nameOf(section)}` : `Home section ${where}`;
    if (where === 'header') return readable(`${where} ${what}`);
    if (pageName === 'Collection' && what === 'collection_list_slider') return 'Collection slider';
    return '';
  };

  const send = (name, category, label, url, position) => {
    const payload = {
      event: 'GA4event',
      'ga4-event-name': name,
      'ga4-event-p1-name': 'event_category',
      'ga4-event-p1-value': category,
      'ga4-event-p2-name': 'event_label',
      'ga4-event-p2-value': label,
      'ga4-event-p3-name': 'link_url',
      'ga4-event-p3-value': url,
      'ga4-event-p4-name': 'theme',
      'ga4-event-p4-value': themeName,
      'ga4-event-p5-name': 'section_position',
      'ga4-event-p5-value': position || '',
    };
    if (live) (window.dataLayer = window.dataLayer || []).push(payload);
    else console.debug('[section-tracking]', payload);
  };

  // Overlays with no section (Quick View, body-level drawers) read by their id: "Home / Overlay QuickView Shared"
  const overlayCategory = (el) => `${templateName} / ${readable(`overlay ${el.id || el.localName}`)}`;
  // Where an element reports from: its section, or the Quick View it sits in (the product loads outside every section), else nowhere
  const placeOf = (el) => {
    const section = el.closest('.shopify-section');
    if (section) return { section, category: categoryOf(section) };
    const quickView = el.closest('quick-view-modal');
    return quickView ? { section: null, category: overlayCategory(quickView) } : null;
  };

  // Flair banners and badges (app blocks) draw in shadow roots: the event lands on the host. A linked <flair-item> inside carries
  // the link as its href property; its text sits in its own shadow root. Flair opens it on Enter with no click (focus is the item,
  // so nothing below it is on the path), so Enter counts too. True when it was a Flair link
  const flairClick = (e) => {
    const host = e.target;
    const item = /^flair-(banners|badges)$/.test(host.localName) && e.composedPath().find((n) => n.localName === 'flair-item' && n.href);
    if (!item) return false;
    const place = placeOf(host);
    if (place) {
      toClarity('event', 'section_click');
      toClarity('set', 'section_click', place.category);
      const kind = host.localName === 'flair-badges' ? 'badge' : 'banner';
      const text = (item.shadowRoot && item.shadowRoot.querySelector('.root')) || item;
      send('section_click', place.category, `Flair ${kind}: ${clean(text.innerText)}`, pathOf(item.href), place.section ? positionOf(place.section) : 'overlay');
    }
    return true;
  };
  document.addEventListener('keydown', (e) => e.key === 'Enter' && !e.repeat && flairClick(e), true);

  // The phone grid's ADD TO CART clicks the card's Quick View button from its own handler: one tap, one event.
  // A shopper's click has eventPhase 0 once it's done, so keyboard picks (Bloomreach's Enter fires a scripted click) still count
  let shopperClick;
  document.addEventListener(
    'click',
    (e) => {
      if (e.isTrusted) shopperClick = e;
      else if (shopperClick && shopperClick.eventPhase) return;
      if (flairClick(e)) return;
      const el = e.target.closest && e.target.closest('a[href], button, [role="button"], summary, .sort-option, .bloomreach-header__filter-wrapper, .clear-filters');
      if (!el) return;
      const place = placeOf(el);
      if (!place) return;
      const { section, category } = place;
      // Controls that aren't links or buttons: tab and menu opens, the Bloomreach sort, filter panel and Clear all. They never feed Clarity funnel steps
      const control = !el.matches('a[href], button, [role="button"]');
      // Opens only, and not FAQ opens (her call 10/12); re-picking the current sort isn't a choice
      if (el.localName === 'summary' && (el.parentElement.open || (section && nameOf(section) === 'faq'))) return;
      if (el.classList.contains('sort-option') && el.classList.contains('active')) return;

      const banner = el.closest('.bloomreach-campaign-banner');
      const card = el.closest('.grid-banner__item, .multicolumn-card, .button-list__item, .swiper-slide');
      const href = el.getAttribute('href') || '';
      const path = pathOf(href || submitTo(el));
      // section_click is navigation only; slider arrows, add to cart and quantity go as section_interact
      const nav = !!(href || path);

      if (nav) {
        toClarity('event', 'section_click');
        toClarity('set', 'section_click', category);
      }
      const step = !section || control ? '' : banner ? 'Campaign banner' : stepOf(section);
      if (step) toClarity('event', `Click: ${step}`);
      // Cart links carry the item count ("Cart3"); drop it
      const text = banner ? campaignLabel(banner) : path === '/cart' ? clean(linkText(el).replace(/\d+/g, ' ')) : linkText(el);
      const shown = el.localName === 'summary' ? `Open: ${text}` : el.classList.contains('sort-option') ? `Sorted: ${text}` : text;
      // Numbered by the reported path, so "?_pos=1" and "?_pos=2" on one product share a number
      const paths = section ? [...new Set([...section.querySelectorAll('a[href]')].map((a) => pathOf(a.getAttribute('href'))))] : [];
      const label = section && !control && numbered(section) ? `${href ? paths.indexOf(path) + 1 : '-'} ${shown}` : shown;
      send(nav ? 'section_click' : 'section_interact', category, label, path, section ? positionOf(section, card) : 'overlay');
    },
    true
  );

  // Picks: Bloomreach filter checkboxes and price slider, product option radios and selects, the sticky bar's variant select.
  // Shopper changes only: the theme re-fires change when it syncs pickers (sticky bar, variant id), and those aren't trusted
  document.addEventListener(
    'change',
    (e) => {
      const el = e.target;
      if (!e.isTrusted || !el.closest) return;
      const place = placeOf(el);
      if (!place) return;
      const filter = el.closest('.filters-content__group');
      let label = '';
      if (filter && el.type === 'checkbox') {
        // A filter going on, "Size: 3T"; taking one off isn't counted
        if (!el.checked) return;
        const title = filter.querySelector('.filters-content__title');
        label = `${clean(title && title.textContent)}: ${clean(el.value)}`;
      } else if (filter && el.type === 'range') {
        // Change fires once per slider release, not while dragging
        const [low, high] = [...filter.querySelectorAll('input[type="range"]')].map((r) => `$${Math.round(parseFloat(r.value))}`);
        label = `Price: ${low}-${high}`;
      } else if (el.classList.contains('sticky-atc-bar__variant-select')) label = 'Variant';
      else if (el.closest('variant-selects') && (el.type === 'radio' || el.localName === 'select')) {
        // The journey, not the item: "Size", not "3T". Radios are named "size-1" (with a trailing newline), selects "options[Size]"
        label = readable(el.name.trim().replace(/^options\[(.*)\]$/, '$1').replace(/-\d+$/, ''));
      }
      if (!label) return;
      send('section_interact', place.category, label, '', place.section ? positionOf(place.section) : 'overlay');
    },
    true
  );

  // Views: main + footer sections, homepage grid banner and footer cards, and Bloomreach campaign banners, once per page, after 1s at half visible (or half the screen).
  const heading = (section) => {
    const h = section.querySelector('h1, h2, h3, .card-media__heading');
    // Hyper's fade-up keeps the heading hidden until it animates in, and hidden text has no innerText
    return h ? clean(h.innerText) || clean(h.textContent) : '';
  };
  const viewOf = (target) => {
    const section = target.classList.contains('shopify-section') ? target : target.closest('.shopify-section');
    if (target.classList.contains('bloomreach-campaign-banner')) send('section_view', categoryOf(section), campaignLabel(target), '', positionOf(section));
    else {
      // A card with no heading (shop by child buttons) is labeled by its link text, or its own text when it has no single link
      const card = target === section ? null : target;
      const link = card && linkOf(card) && card.querySelector('a[href]');
      send('section_view', categoryOf(section), heading(target) || (card ? linkText(link || card) : ''), linkOf(target), positionOf(section, card));
    }
  };
  const timers = new Map();
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const section = entry.target;
        const seen =
          entry.isIntersecting &&
          entry.boundingClientRect.height > 0 &&
          (entry.intersectionRatio >= 0.5 || entry.intersectionRect.height >= window.innerHeight / 2);
        if (seen && !timers.has(section)) {
          timers.set(
            section,
            setTimeout(() => {
              io.unobserve(section);
              viewOf(section);
            }, 1000)
          );
        } else if (!seen && timers.has(section)) {
          clearTimeout(timers.get(section));
          timers.delete(section);
        }
      });
    },
    { threshold: Array.from({ length: 21 }, (_, i) => i / 20) }
  );
  document.querySelectorAll('.shopify-section').forEach((s) => {
    if ((main && s.parentElement === main) || s.classList.contains('shopify-section-group-footer-group')) {
      (trackedCards(s).length ? trackedCards(s) : [s]).forEach((t) => io.observe(t));
    }
  });
  document.querySelectorAll('.bloomreach-campaign-banner').forEach((b) => b.closest('.shopify-section') && io.observe(b));

  // Drawers and modals (cart, Quick View, mobile menu, popups): every open counts.
  const isModal = (el) =>
    typeof ModalComponent !== 'undefined' ? el instanceof ModalComponent : /-(drawer|modal)$/.test(el.localName);
  new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      const el = m.target;
      if (m.oldValue !== null || !el.hasAttribute('open') || !isModal(el)) return;
      const section = el.closest('.shopify-section');
      send('section_view', section ? categoryOf(section) : overlayCategory(el), 'open', '', section ? positionOf(section) : 'overlay');
    });
  }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'], attributeOldValue: true });

  // Layout shifts, collection pages: one layout_shift at the first hide once CLS reaches 0.1, naming the element in its biggest shift.
  // Clarity marks and tags each burst as it takes over as the page's worst. Last and wrapped, so it can't stop the tracking above
  try {
    if (pageName === 'Collection' && ((window.PerformanceObserver && PerformanceObserver.supportedEntryTypes) || []).includes('layout-shift')) {
      // "div.card.product-card": tag + up to 3 sorted classes, numbers dropped ("card-8123" is "card"), ids left out
      const shapeOf = (node) => {
        const el = node && (node.nodeType === 1 ? node : node.parentElement);
        if (!el) return { name: 'unknown', category: `${templateName} / outside sections`, position: '' };
        const classes = typeof el.className === 'string' ? [...new Set(el.className.split(/\s+/).map((c) => c.replace(/[-_]?\d+/g, '')).filter(Boolean))].sort().slice(0, 3) : [];
        const section = el.closest('.shopify-section');
        return { name: clean([el.localName, ...classes].join('.')), category: section ? categoryOf(section) : `${templateName} / outside sections`, position: section ? positionOf(section) : '' };
      };
      let cls, burst, first, last, biggest, worst, marked, sent;
      const reset = () => { cls = 0; burst = 0; first = 0; last = 0; biggest = null; worst = null; marked = null; sent = false; };
      const take = (entries) =>
        entries.forEach((e) => {
          if (e.hadRecentInput) return;
          // Chrome's CLS: a 1s gap, or 5s since the burst began, starts a new burst; the page's CLS is its worst burst
          if (!burst || e.startTime - last >= 1000 || e.startTime - first >= 5000) { burst = 0; first = e.startTime; biggest = null; }
          burst += e.value;
          last = e.startTime;
          // First element source, else a text node's parent (on purpose); read now, while it's still on the page
          if (!biggest || e.value > biggest.value) biggest = { value: e.value, ...shapeOf((e.sources.find((s) => s.node && s.node.nodeType === 1) || e.sources[0] || {}).node) };
          if (burst > cls) {
            // This burst takes over as the worst at 0.1+: one Clarity event and tag, at that moment (Clarity keeps every tag value)
            if (burst >= 0.1 && marked !== first) {
              marked = first;
              toClarity('event', 'layout_shift');
              toClarity('set', 'layout_shift', biggest.name);
            }
            cls = burst;
            worst = biggest;
          }
        });
      reset();
      const po = new PerformanceObserver((list) => take(list.getEntries()));
      po.observe({ type: 'layout-shift', buffered: true });
      // CLS at first hide, not final: a tab that comes back and shifts more isn't re-sent
      const report = () => {
        take(po.takeRecords());
        if (sent || cls < 0.1) return;
        sent = true;
        const bucket = cls >= 0.5 ? '0.5+' : cls >= 0.25 ? '0.25-<0.5' : '0.1-<0.25';
        send('layout_shift', worst.category, `${bucket} ${worst.name}`, location.pathname, worst.position);
      };
      document.addEventListener('visibilitychange', () => document.visibilityState === 'hidden' && report());
      addEventListener('pagehide', report);
      // Back/forward cache: drop the old visit's leftovers, then count the restored page fresh
      addEventListener('pageshow', (e) => {
        if (!e.persisted) return;
        po.takeRecords();
        reset();
      });
    }
  } catch (err) {
    console.debug('[section-tracking]', 'layout_shift off', err);
  }
})();
